export default {
    account_existed: "指定的用户名不存在。",
    account_not_exists: "查无此用户名信息.",

    invalid_password: "登录密码录入有误！",
    insufficient_balance: "账户结余不足！",

    // verify_failed: "认证号码出错",

    withdrawalAmountMustGreaterThan0: "提现额的具体数值必须超过0。",
    block: "你的投注账户处于被禁用状态。",

    requestTooFrequentAtLeast2Minutes: "任务要求提交时间过于频密。请在2分钟再重试提交。",

    isRequired: "请录入一个 {fname}.",
    isMinValue: "{fname} 必须拥有不少于 {fvalue}。",
    isMaxValue: "{fname} 必须少过或等同于 {fvalue} 。",
    isMinLength: "{fname} 必须拥有不少于 {fvalue} 字元。",
    isMaxLength: "{fname} 必须少过或等同于 {fvalue} 字元。",
    isAlpha: "{fname} 只接受字母字符而已。",
    isAlphaNum: "{fname} 只接受包含数字与字母在内的字符串而已。",
    isNumeric: "{fname} 只接受数字字元而已。",
    isEmail: "{fname} 只接受有效且仍在使用的电邮地址而已。",
    isIpAddress: "{fname} 只接受有效的 IPv4 网址格式而已。",
    isSameAs: "{fname}必须与 {fname2} 保持一致。",
    isUrl: "{fname} 只接受 URLs 网址格式而已。",
    containAlphaNum: "{fname} 必须包含至少一个字母和一个数字在内。",
    selectOption: "请选择一项 {fname}",
    notSameAs: "{fname} 不得与 {fname2} 相同。.",
    isBetween: "{fname} 必须介于 {min} 和 {max} 之间。.",
    checkFormat: "请按照以下格式录入接收者的手机号码：: 012 3456789 或 012 34567890",
    invalid_referral_code: "邀友代码录入有误",
    accountIdOnlyNumber: "只可录入数字字符而已。",
    passwordStrengthError: "创建一组你专属的登录密码。密码必须由至少6-20 个字符组成且得包含数字与大小写字母。",
    tacCodeRequired: "交易识别码 (TAC) 认证不得留空。",
    invalid_tac: "交易识别码 (TAC) 录入有误",
    tac_is_valid: "已把交易识别码 (TAC) 发送至你的手机号码。",
    loginFailed: "登录失败",
    loginSucceed: "登录成功",
    usernameRequired : "请录入用户名",
    passwordRequired : "请录入登录密码",
    logoutSucceed : "成功登出账户",
    logoutFailed : "登出失败",
    requestSucceed: "任务要求提交成功",
    requestFailed : "任务要求提交失败",
    requestProcessing : "你的任务要求正在处理中。",
    requestDelayed: "任务要求被推迟",
    verificationCodeRequired: "交易识别码 (TAC) 认证不得留空。",
    newPasswordRequired: "全新登录密码不得留空。",
    bankIdRequired: "请选择银行",
    bankNameRequired: "银行名称不得留空。",
    bankAccHolderRequired : "银行户名不得留空。",
    bankAccNoRequired: "银行账号不得留空。",
    depositAmountRequired: "请录入存款额",
    dateRequired: "请选择日期",
    bonusIdRequired: "请选择欲申领的赠礼。",
    session_not_exists: "你登录的时限已过, 请重新登录",
    session_expired : '时段结束',
    account_inactive: "用户名/投注账户处于不活跃状态",
    account_exists: "用户/账户标识已被使用。",
    OK: "交易识别码 (TAC) 发送成功", // for tac code
    ok: "交易识别码 (TAC) 发送成功", // for tac code
    CLOSE: "抱歉，您的登录似乎遇到技术问题。请联系在线客服团队以获取更多信息。",
    close: "抱歉，您的登录似乎遇到技术问题。请联系在线客服团队以获取更多信息。",
    accountIdRequired: '请录入用户名',
    session_expired : '时段结束',
    phoneRequired: '请输入电话号码',

    app_id_required: "申请标识不得留空",
    permission_denied: "权限被拒",
    account_id_required: "用户名/投注账户标识不得留空",
    verification_code_required: "认证码不得留空",
    account_inactive: "用户名/投注账户处于不活跃状态",
    verify_failed: "认证过程失败",
    parent_account_inactive: "上线账户处于不活跃状态",
    transfer_id_required: "转款标识不得留空",
    credit_amount_required: "收款额不得留空",
    duplicate_credit_record: "重复的提现记录",
    member_wallet_not_exists: "查无玩家的钱包信息",
    debit_amount_required: "转款额不得留空。",
    duplicate_debit_record: "重复的存款记录",
    result_exists: "已查阅到赛事结果记录。",
    debit_record_not_found: "查无任何存款记录。",
    bank_id_required: "银行标识不得留空。",
    bank_acc_no_required: "银行账号不得留空。",
    bank_acc_holder_required: "银行户名不得留空。",
    bank_already_setup: "银行账户已被设置。",
    platform_required: "平台不得留空。",
    parent_not_exists: "查无此上线信息",
    parent_id_required: "上线标识不得留空。",
    password_required: "登录密码不得留空。",
    contact_phone_required: "联系号码不得留空。",
    account_exists: "用户/账户标识已被使用。",
    vip_mode_not_exists: "查无此尊荣模式。",
    ticket_id_required: "任务票单标识不得留空。",
    ref_id_required: "参考标识不得留空",
    ticket_not_exists: "查无此任务票单。",
    ticket_processed: "任务票单已被处理。",
    min_deposit_not_met: "存款额必须至少等同于最低起存额。",
    ongoing_promotion: "你尚参与着正在进行中的优惠活动。请在以后再提出申领要求。",
    invalid_promo_package: "优惠活动配套出错",
    promo_min_deposit_not_met: "存款额仍未达到本优惠活动所规定的最低起存额·要求。",
    claim_promo_only_once_a_day: "本优惠活动每天只能申领一次而已。",
    first_deposit_unmet: "已申领了每日首存彩金奖励。",
    newbie_unmet: "已领取了新手专属的开户迎新彩金奖励。",
    claim_promo_only_once: "本优惠活动只能申领一次而已。",
    inner_catch: "意想不到的故障",
    systemError: "系统哦故障",
    deposit_amount_required: "存款额不得留空。",
    target_bank_id_required: "目标银行标识不得留空。",
    target_bank_acc_no_required: "目标银行账号不得留空。",
    target_bank_acc_holder_required: "目标银行户名不得留空。",
    deposit_date_required: "存款日期不得留空。",
    deposit_method_required: "存款方式不得留空。",
    min_deposit_not_set: "尚未设置最低起存额。",
    min_balance_not_set: "尚未设置现有结余最低额。",
    ibank_account_not_exists: "查无此IBANK88账户信息",
    ibank_account_inactive: "IBANK88账户处于不活跃状态。",
    withdrawal_amount_required: "提现额不得留空",
    min_withdrawal_not_set: "尚未设置最低提现额。",
    bank_member_not_exists: "查无目标玩家的银行账户信息。",
    promotion_requirement_not_met: "尚未达成优惠活动所规定的获赏要求。",
    invalid_promotion: "优惠活动出错",
    new_password_required: "全新登录密码不得留空。",
    multiplier_not_found: "系统当前未能处理你所提交的任务要求，请在稍后重试。",
    contact_phone_exists: "此手机号码已被使用。",
    BLOCK: "你的投注账户已被禁用。",
    tac_expired: "你的交易识别码 (TAC)已超出执行时间。请再申请新的交易识别码 (TAC)",
    tac_not_validate: "交易识别码 (TAC) 尚未被认证",
    exceed_max_withdrawal: "超出提现上限。",
    bank_member_inactive: "银行用户处于不活跃状态。",
    bank_member_exists: "此银行账号已被使用了。",
    never_deposited : "你必须曾进行过一次有效的存款操作后方可把资金转款到你友人的投注账户内。",
    transferAmountMustGreaterThanEqual5: "转款额必须超过或等值于 5令吉。",
    // account_not_exists : "查无此账户信息。"
    permission_denied : "接收者账户不是来自同一个娱乐游戏平台。",
    ongoing_promotion : "你尚参与着正在进行中的优惠活动。",
    insufficient_balance : "账户结余不足",
    transfer_success: "转款成功",
    sender_id_required: "发送者标识不得留空",
    recipient_id_required: "接收者标识不得留空",
    tac_validated: "交易识别码 (TAC) 正确无误。",
    pending_result_in_game: "游戏结果待通知",
    accountIdOnlyNumber: "只限还在使用的有效手机号码而已。",
    unfinishgamedetected: "请在闯过免费游戏关卡后方才执行此步骤。",
    duplicate_review: "你在较早前已提交了一份玩后感言了。",
    exceed_withdrawal_frequency: "已超出提现次数(一天五次)",
    requestTooFrequentAtLeast2Minutes: "您的请求正在处理中， 请稍等",
    invalidPhoneNumberFormat: "请输入正确的电话号码格式",
    gspayUnderMaintenance: "系统正在维护中",
    affiliate_not_exists: "代理链接不存在",
    couponeCodeRequired: "请输入优惠卷代码",
    coupon_code_required: "请输入优惠卷代码",
    coupon_not_available: "优惠卷代码无效",
    contact_email_registered: "电子邮件地址已经存在",
    invalidEmailFormat: "电子邮件地址无效",
    emailRequired: "请输入电子邮件地址",
    paymentMethodRequired: "请选择付款方式",
    depositMethodRequired: "请选择存款方式",
    telcoCodeRequired: "请选择电信公司",
    reloadPinCodeRequired: "请输入充值密码"
}